<template>
  <a-card :bordered="false" class="submit-member-auth">
    <Breadcrumb routeName="MemberList" toName="提交成员认证" goPathName="成员列表"></Breadcrumb>
    <div class="auth-page">
      <h2 class="auth-title">完成认证即可开始</h2>
      <div class="auth-tabs">
        <div
          class="auth-tab"
          :class="{ active: authType === 'personal' }"
          @click="authType = 'personal'"
        >个人
        </div>
        <div
          class="auth-tab"
          :class="{ active: authType === 'enterprise' }"
          @click="authType = 'enterprise'"
        >企业
        </div>
      </div>

      <!-- 个人认证 -->
      <a-form v-show="authType === 'personal'" :form="personalForm" class="auth-form">
        <div class="auth-notice">
          <div class="auth-notice-title">个人认证说明</div>
          <ol>
            <li>《互联网平台企业涉税信息报送规定》（国务院令第 810 号，行政法规）—— 税务总局，2025-10-01 起施行</li>
            <li>国家税务总局公告 2025 年第 15 号：《关于互联网平台企业报送涉税信息有关事项的公告》（细化报送口径、报表）</li>
            <li>国家税务总局公告 2025 年第 16 号：《关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》（扣缴、代办申报规则）</li>
            <li>国家税务总局公告 2018 年第 61 号：个人所得税全员全额扣缴申报基础规则（传统支付扣缴）</li>
          </ol>
        </div>
        <a-form-item label="身份证国徽页" v-bind="formItemLayout" required>
          <div class="upload-dragger-wrap">
            <a-upload-dragger
              name="file"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              :before-upload="handleBeforeUploadImage"
              @change="info => handleUploadChange(info, 'personalCardRear')"
            >
              <div v-if="uploadLoading.personalCardRear" class="upload-loading">
                <a-icon type="loading"/>
                <p class="ant-upload-text">上传中...</p>
              </div>
              <img v-else-if="uploadImages.personalCardRear" :src="uploadImages.personalCardRear" class="preview-img" alt=""/>
              <template v-else>
                <p class="ant-upload-text">点击上传 / 拖拽到此区域</p>
              </template>
            </a-upload-dragger>
            <div class="upload-tip">中华人民共和国身份证国徽页</div>
          </div>
        </a-form-item>
        <a-form-item label="身份证人像页" v-bind="formItemLayout" required>
          <div class="upload-dragger-wrap">
            <a-upload-dragger
              name="file"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              :before-upload="handleBeforeUploadImage"
              @change="info => handleUploadChange(info, 'personalCardPositive')"
            >
              <div v-if="uploadLoading.personalCardPositive" class="upload-loading">
                <a-icon type="loading"/>
                <p class="ant-upload-text">上传中...</p>
              </div>
              <img v-else-if="uploadImages.personalCardPositive" :src="uploadImages.personalCardPositive" class="preview-img" alt=""/>
              <template v-else>
                <p class="ant-upload-text">点击上传 / 拖拽到此区域</p>
              </template>
            </a-upload-dragger>
            <div class="upload-tip">中华人民共和国身份证人像页</div>
          </div>
        </a-form-item>
        <a-form-item label="姓名" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['staffName', { rules: [{ required: true, message: '请输入姓名' }] }]"
          />
        </a-form-item>
        <a-form-item label="身份证号码" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['staffCardNo', { rules: [{ required: true, message: '请输入身份证号码' }] }]"
          />
        </a-form-item>
        <a-form-item class="submit-item">
          <a-button type="primary" class="submit-btn" :loading="saveLoading" @click="submitPersonal">提交认证</a-button>
        </a-form-item>
      </a-form>

      <!-- 企业认证 -->
      <a-form v-show="authType === 'enterprise'" :form="enterpriseForm" class="auth-form">
        <div class="auth-notice">
          <div class="auth-notice-title">企业认证说明</div>
          <ol>
            <li>《互联网平台企业涉税信息报送规定》（国务院令第 810 号，行政法规）—— 税务总局，2025-10-01 起施行</li>
            <li>国家税务总局公告 2025 年第 15 号：《关于互联网平台企业报送涉税信息有关事项的公告》（细化报送口径、报表）</li>
            <li>国家税务总局公告 2025 年第 16 号：《关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》（扣缴、代办申报规则）</li>
            <li>国家税务总局公告 2018 年第 61 号：个人所得税全员全额扣缴申报基础规则（传统支付扣缴）</li>
          </ol>
        </div>
        <div class="section-title">企业基本信息</div>
        <a-form-item label="营业执照" v-bind="formItemLayout" required>
          <div class="upload-dragger-wrap">
            <a-upload-dragger
              name="file"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              :before-upload="handleBeforeUploadImage"
              @change="info => handleUploadChange(info, 'businessLicense')"
            >
              <div v-if="uploadLoading.businessLicense" class="upload-loading">
                <a-icon type="loading"/>
                <p class="ant-upload-text">上传中...</p>
              </div>
              <img v-else-if="uploadImages.businessLicense" :src="uploadImages.businessLicense" class="preview-img" alt=""/>
              <template v-else>
                <p class="ant-upload-text">点击上传 / 拖拽到此区域</p>
              </template>
            </a-upload-dragger>
          </div>
        </a-form-item>
        <a-form-item label="社会统一信用代码" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['creditCode', { rules: [{ required: true, message: '请输入社会统一信用代码' }] }]"
          />
        </a-form-item>
        <a-form-item label="公司地址" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['companyAddress', { rules: [{ required: true, message: '请输入公司地址' }] }]"
          />
        </a-form-item>

        <div class="section-title">法定代表人信息</div>
        <a-form-item label="身份证国徽页" v-bind="formItemLayout" required>
          <div class="upload-dragger-wrap">
            <a-upload-dragger
              name="file"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              :before-upload="handleBeforeUploadImage"
              @change="info => handleUploadChange(info, 'legalCardRear')"
            >
              <div v-if="uploadLoading.legalCardRear" class="upload-loading">
                <a-icon type="loading"/>
                <p class="ant-upload-text">上传中...</p>
              </div>
              <img v-else-if="uploadImages.legalCardRear" :src="uploadImages.legalCardRear" class="preview-img" alt=""/>
              <template v-else>
                <p class="ant-upload-text">点击上传 / 拖拽到此区域</p>
              </template>
            </a-upload-dragger>
            <div class="upload-tip">中华人民共和国身份证国徽页</div>
          </div>
        </a-form-item>
        <a-form-item label="身份证人像页" v-bind="formItemLayout" required>
          <div class="upload-dragger-wrap">
            <a-upload-dragger
              name="file"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              :before-upload="handleBeforeUploadImage"
              @change="info => handleUploadChange(info, 'legalCardPositive')"
            >
              <div v-if="uploadLoading.legalCardPositive" class="upload-loading">
                <a-icon type="loading"/>
                <p class="ant-upload-text">上传中...</p>
              </div>
              <img v-else-if="uploadImages.legalCardPositive" :src="uploadImages.legalCardPositive" class="preview-img" alt=""/>
              <template v-else>
                <p class="ant-upload-text">点击上传 / 拖拽到此区域</p>
              </template>
            </a-upload-dragger>
            <div class="upload-tip">中华人民共和国身份证人像页</div>
          </div>
        </a-form-item>
        <a-form-item label="姓名" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['legalName', { rules: [{ required: true, message: '请输入姓名' }] }]"
          />
        </a-form-item>
        <a-form-item label="身份证号码" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['legalCardNo', { rules: [{ required: true, message: '请输入身份证号码' }] }]"
          />
        </a-form-item>

        <div class="section-title">联系人信息</div>
        <a-form-item label="姓名" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['contactName', { rules: [{ required: true, message: '请输入姓名' }] }]"
          />
        </a-form-item>
        <a-form-item label="手机号" v-bind="formItemLayout">
          <a-input
            placeholder="请输入"
            v-decorator="['contactMobile', { rules: [{ required: true, message: '请输入手机号' }] }]"
          />
        </a-form-item>
        <a-form-item class="submit-item">
          <a-button type="primary" class="submit-btn" :loading="saveLoading" @click="submitEnterprise">提交认证</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixin from '@/utils/mixins/formMixins'

export default {
  name: 'SubmitMemberAuth',
  components: { Breadcrumb },
  mixins: [formMixin],
  data() {
    return {
      staffId: null,
      authType: 'personal',
      personalForm: this.$form.createForm(this, { name: 'personalForm' }),
      enterpriseForm: this.$form.createForm(this, { name: 'enterpriseForm' }),
      uploadImages: {
        personalCardRear: '',
        personalCardPositive: '',
        businessLicense: '',
        legalCardRear: '',
        legalCardPositive: ''
      },
      uploadLoading: {
        personalCardRear: false,
        personalCardPositive: false,
        businessLicense: false,
        legalCardRear: false,
        legalCardPositive: false
      },
      formItemLayout: {},
      formItemLayoutBtn: {}
    }
  },
  mounted() {
    this.initPage()
  },
  activated() {
    this.initPage()
  },
  methods: {
    initPage() {
      this.staffId = this.getPageParams().staffId
      this.authType = 'personal'
      this.uploadImages = {
        personalCardRear: '',
        personalCardPositive: '',
        businessLicense: '',
        legalCardRear: '',
        legalCardPositive: ''
      }
      this.uploadLoading = {
        personalCardRear: false,
        personalCardPositive: false,
        businessLicense: false,
        legalCardRear: false,
        legalCardPositive: false
      }
      this.$nextTick(() => {
        this.personalForm && this.personalForm.resetFields()
        this.enterpriseForm && this.enterpriseForm.resetFields()
      })
    },
    handleUploadChange(fileInfo, key) {
      if (fileInfo.file.status === 'uploading') {
        this.$set(this.uploadLoading, key, true)
      } else if (fileInfo.file.status === 'done') {
        this.uploadImages[key] = this.getLatestUrlFromFileList(fileInfo.fileList)
        this.$set(this.uploadLoading, key, false)
      } else if (fileInfo.file.status === 'error') {
        this.$set(this.uploadLoading, key, false)
        this.$message.error('上传失败，请重试')
      }
    },
    submitPersonal() {
      if (!this.uploadImages.personalCardRear) {
        this.$message.warning('请上传身份证国徽页')
        return
      }
      if (!this.uploadImages.personalCardPositive) {
        this.$message.warning('请上传身份证人像页')
        return
      }
      this.personalForm.validateFields((err, values) => {
        if (err) return
        this.submitAuthRequest({
          authType: 1,
          realName: values.staffName,
          cardNo: values.staffCardNo,
          cardPositive: this.uploadImages.personalCardPositive,
          cardRear: this.uploadImages.personalCardRear
        })
      })
    },
    submitEnterprise() {
      if (!this.uploadImages.businessLicense) {
        this.$message.warning('请上传营业执照')
        return
      }
      if (!this.uploadImages.legalCardRear) {
        this.$message.warning('请上传身份证国徽页')
        return
      }
      if (!this.uploadImages.legalCardPositive) {
        this.$message.warning('请上传身份证人像页')
        return
      }
      this.enterpriseForm.validateFields((err, values) => {
        if (err) return
        this.submitAuthRequest({
          authType: 2,
          realName: values.legalName,
          cardNo: values.legalCardNo,
          cardPositive: this.uploadImages.legalCardPositive,
          cardRear: this.uploadImages.legalCardRear,
          license: this.uploadImages.businessLicense,
          creditCode: values.creditCode,
          companyAddress: values.companyAddress,
          contactName: values.contactName,
          contactMobile: values.contactMobile
        })
      })
    },
    submitAuthRequest(params) {
      if (!this.staffId) {
        this.$message.warning('缺少成员ID，请从成员列表选择后进入')
        return
      }
      this.saveLoading = true
      this.getHttpServices().getUserService()
        .post('staff/v2/submitStaffAuth', {
          staffId: this.staffId,
          ...params
        })
        .then(() => {
          this.$message.success('提交成功')
          setTimeout(() => this.backEvent(), 500)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../CustomPage";

.submit-member-auth {
  .auth-page {
    max-width: 780px;
    margin: 0 auto;
    padding: 20px 24px 40px;
  }

  .auth-title {
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    color: #262626;
    margin: 10px 0 24px;
  }

  .auth-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;

    .auth-tab {
      width: 120px;
      height: 36px;
      line-height: 34px;
      text-align: center;
      border: 1px solid #d9d9d9;
      color: #595959;
      cursor: pointer;
      background: #fff;
      user-select: none;

      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
        margin-left: -1px;
      }

      &.active {
        color: #FAAD14;
        border-color: #FAAD14;
        z-index: 1;
        position: relative;
      }
    }
  }

  .auth-notice {
    background: #e6f4ff;
    border-radius: 4px;
    padding: 16px 20px;
    margin-bottom: 24px;
    color: #595959;
    font-size: 13px;
    line-height: 1.8;

    .auth-notice-title {
      font-weight: 500;
      color: #262626;
      margin-bottom: 6px;
    }

    ol {
      margin: 0;
      padding-left: 18px;
    }
  }

  .section-title {
    position: relative;
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    margin: 24px 0 20px;

    &::after {
      content: '';
      display: block;
      height: 1px;
      background: #f0f0f0;
      margin-top: 12px;
    }
  }

  .auth-form {
    /deep/ .ant-form-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 24px;
    }

    /deep/ .ant-form-item-label {
      flex: 0 0 160px;
      width: 160px;
      float: none;
      text-align: right;
      line-height: 32px;
      padding-right: 12px;
      white-space: nowrap;
      overflow: visible;
    }

    /deep/ .ant-form-item-control-wrapper {
      flex: 1;
      float: none;
      width: auto !important;
      max-width: 420px;
    }

    .ant-input {
      width: 100%;
      max-width: 400px;
    }

    .upload-dragger-wrap {
      width: 100%;
      max-width: 400px;

      /deep/ .ant-upload.ant-upload-drag {
        height: 220px;
        background: #fafafa;
      }

      /deep/ .ant-upload-drag-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }

      .ant-upload-text {
        color: #8c8c8c;
        font-size: 14px;
        margin: 0;
      }

      .upload-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .anticon {
          font-size: 28px;
          color: #FAAD14;
          margin-bottom: 8px;
        }
      }

      .preview-img {
        max-width: 100%;
        max-height: 200px;
        object-fit: contain;
      }

      .upload-tip {
        margin-top: 8px;
        color: #bfbfbf;
        font-size: 12px;
      }
    }

    .submit-item {
      /deep/ .ant-form-item-control-wrapper {
        margin-left: 160px;
        max-width: none;
      }
    }

    .submit-btn {
      min-width: 160px;
      height: 36px;
    }
  }
}
</style>
